<span
  class="action-button action-button-delete grey-button"
  [ngClass]="{ 'responsive-label': responsiveLabel }" [ngbTooltip]="title" role="button" tabindex="0"
>
  <my-global-icon iconName="delete" aria-hidden="true"></my-global-icon>

  <span class="button-label" *ngIf="label">{{ label }}</span>
</span>
